// @ts-nocheck

export const localeCodes =  [
  "pt",
  "es"
]
export const localeLoaders = {
  pt: [],
  es: []
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/ee4e6a16" /* webpackChunkName: "config_i18n_46config_46ts_ee4e6a16" */)
]
export const normalizedLocales = [
  {
    code: "pt",
    language: "pt-PT",
    domain: "https://happybox.familycard.pt"
  },
  {
    code: "es",
    language: "es-ES",
    domain: "https://happybox.familycard.es"
  }
]

